import { Badge } from "@mantine/core";
import { useTranslation } from "react-i18next";

export function ActiveBadge({ active }: { active: boolean }) {
	const { t } = useTranslation();
	return (
		<Badge
			color={active ? "green" : "gray"}
			variant="light"
			tt="none"
			size="md"
			styles={{
				root: { flexShrink: 0 },
				label: { overflow: "visible", textOverflow: "clip" },
			}}
		>
			{active ? t("common.active") : t("common.inactive")}
		</Badge>
	);
}
